@if (showCallsheetButton()) {
    <app-document-download-button [disabled]="!performance?.hasCallsheet()"
                                  [downloadButtonText]="performance?.hasCallsheet() ? shortNames ? 'Callsheet' : 'Download Callsheet' : shortNames ? 'Callsheet' : 'Geen Callsheet'"
                                  [fill]="performance?.hasCallsheet() ? 'solid' : 'clear'"
                                  [url]="performance?.getCallsheetUrl()"
                                  class="callsheet-upload-button" />
}

@if (showEftelingShowreportButton() && showShowreport && !isToday()) {
    <app-document-download-button [disabled]="!hasEftelingShowreport()"
                                  [downloadButtonText]="hasEftelingShowreport() ? 'Download Efteling Showreport' : 'Geen Efteling Showreport'"
                                  [fill]="hasEftelingShowreport() ? 'solid' : 'clear'"
                                  [url]="getEftelingShowreportUrl()"
                                  class="eftelingshowreportButton" />
}
